import { apiVaultSetApiKey } from '@modules/api'

export const API_KEY = 'YotQthOwprkv410aaf6mkGbYFw2tSY7Q'

export default () => apiVaultSetApiKey(API_KEY)
